import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { initLogger } from '@hopin-team/browser-logger';
import {
  getDatadogClientToken,
  getDatadogRumApplicationId,
  getDatadogRumClientToken,
  getEnvironment,
} from '@hopin-team/dashboard-constants';
import { createDashboardReactiveMap } from '@hopin-team/dashboard-shared';
import { GenericRouter } from '@slicesjs/react-router-app';
import { createBrowserHistory } from 'history';
import React from 'react';
import { render } from 'react-dom';

import packageJson from '../package.json';
import DashboardApp from './dashboard-app';

const DATADOG_RUM_SAMPLE_RATE = parseInt(
  process.env.SLICE_PUBLIC_DATADOG_RUM_SAMPLE_RATE ?? '',
);

if (getDatadogClientToken() && process.env.NODE_ENV !== 'development') {
  initLogger({
    clientToken: getDatadogClientToken(),
    env: getEnvironment(),
    service: 'dashboard-app',
  });
} else {
  // in dev, we're sending the logs to our browser console
  datadogLogs.logger.setHandler('console');
}

if (
  getDatadogRumApplicationId() &&
  getDatadogRumClientToken() &&
  process.env.NODE_ENV !== 'development'
) {
  datadogRum.init({
    applicationId: getDatadogRumApplicationId(),
    clientToken: getDatadogRumClientToken(),
    site: 'datadoghq.eu',
    service: 'dashboard-app',
    env: getEnvironment(),
    version: packageJson.version,
    sessionSampleRate: isNaN(DATADOG_RUM_SAMPLE_RATE)
      ? 0
      : DATADOG_RUM_SAMPLE_RATE,
  });
}

const defaultErrorHandler = (error: Error) =>
  console.error('Error creating Dashboard reactive-map', error);

const history = createBrowserHistory();

const reactiveMap = createDashboardReactiveMap({
  clientPackageDetails: `${packageJson.name}/${packageJson.version}`,
  onAsyncError: defaultErrorHandler,
  urlInterface: history,
});

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

render(
  <GenericRouter history={history}>
    <DashboardApp reactiveMap={reactiveMap} />
  </GenericRouter>,
  container,
);
